/**
 * keymapHelpers — tiny pure helpers for the CodeMirror keymap.
 *
 * Lives in lib/ rather than beside the editor because importing anything from
 * MarkdownEditor.js drags CodeMirror in, and CM6 ships ESM that CRA's Jest
 * won't transform — so nothing in that file is unit-testable. These are.
 */

/**
 * alwaysHandled — run a CM6 command but always report the key as handled.
 *
 * CodeMirror tries the NEXT binding for a key whenever a command returns
 * false. For a command we're deliberately overriding, falling through means
 * the CM6 default runs instead — the opposite of what an override is for.
 *
 * Walter 2026-08-10: this is the top-edge duplication bug. `moveLineUp`
 * returns false on the first line (nothing above to swap with), so
 * Alt+Shift+↑ fell through to defaultKeymap's `copyLineUp` and DUPLICATED the
 * line — "when I move stuff at the top edge of the tile it starts duplicating
 * the line". Bottom edge had the same bug via copyLineDown. Wrapping keeps a
 * no-op a no-op.
 */
export function alwaysHandled(command) {
  return (view) => { command(view); return true; };
}
